<!-- <template>
    <section class="desktop_paper_3 31">
      <div class="content_box">
        <div class="title_3">
          <h2 class="title_color_3"></h2>
        </div>
        <div class="img1" bg-url="@/auto/assets/image/眼镜.png" v-bg></div>
        <div class="img1" bg-url="@/auto/assets/image/语音.png" v-bg></div>
        <div class="img1" bg-url="@/auto/assets/image/指环.png" v-bg></div>
        <div class="first_desktop_3" bg-url="@/auto/assets/image/交互.png" v-bg></div>
      </div>
    </section>
  </template> -->
<template>
  <section class="continue_30">
    <div>
      <img src="@/auto/assets/image/30/1.png" style="width: 100%" />
    </div>
    <!-- <div class="content_box">
        <h3>全天候多模态交互</h3> 
        <div class="">
          <img src="@/auto/assets/image/眼镜.png" class=""/>
          <img src="@/auto/assets/image/语音.png" class=""/>
          <img src="@/auto/assets/image/指环.png" class=""/>
          <img src="@/auto/assets/image/交互.png" class=""/>
        </div>  
      </div> -->
  </section>
</template>

<script>
export default {
  name: 'Continue',
}
</script>

<style lang="less" scoped>
.continue_30 {
  // height: 1080px;
  width: 100%;
  position: relative;
  background-color: #111;
  overflow: hidden;
  .announce {
    margin-top: 60px;
    width: 50%;
    color: #acacac;
    font-family: Flyme Sans VF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px; /* 150% */
    letter-spacing: 1px;
  }

  .content_box {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 1200px;
    height: 100%;

    h3 {
      text-align: center;
      font-family: Flyme Sans VF;
      font-size: 72px;
      font-style: normal;
      font-weight: 700;
      line-height: 92px; /* 135% */
      letter-spacing: 4.8px;
      background: linear-gradient(99deg, #ffdfdf 8.71%, #7e8bff 83.77%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  ul {
    display: block;
    list-style-type: disc;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
  }

  .icon {
    width: 90px;
    height: 90px;
    background-size: 100%;
  }

  .font_box {
    padding-left: 30px;
    flex: 1;

    h5 {
      font-weight: 600;
      font-size: 28px;
      line-height: 39px;
      color: #000;
      margin: 0;
    }

    p {
      font-weight: 400;
      font-size: 18px;
      line-height: 28px;
      color: rgba(0, 0, 0, 0.5);
      margin: 6px 0 0 0;
    }
  }
}
</style>
